<template>
  <InvoiceParameterLabel :body="true" :textSm="textSm" :textBold="textBold">
    <slot></slot>
  </InvoiceParameterLabel>
</template>
<script>
import InvoiceParameterLabel from './InvoiceParameterLabel.vue';
export default {
  name: "InvoiceParameterTableBody",
  components: {
    InvoiceParameterLabel,
  },
  props: {
    textSm: {
      type: Boolean,
      default: false,
    },
    textBold: {
      type: Boolean,
      default: false,
    }
  },
}
</script>